import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "checkbox" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "default" }, null, -1)
const _hoisted_3 = { class: "list-group list-group-flush pt-3 m-0" }
const _hoisted_4 = { class: "checkbox" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "default" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!

  return (_openBlock(), _createBlock(_component_el_collapse, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.abilities, (ability, index) => {
        return (_openBlock(), _createBlock(_component_el_collapse_item, {
          title: JSON.parse(ability?.name)[`${_ctx.systemLocale}`].name,
          name: ability.id,
          key: ability
        }, {
          default: _withCtx(() => [
            _createVNode("label", _hoisted_1, [
              _createVNode("input", {
                type: "checkbox",
                value: ability.name,
                id: ability.id + '_' + index,
                onClick: ($event: any) => (_ctx.groupSelectedHandler($event, ability.abilities)),
                class: "parent-checkbox"
              }, null, 8, ["value", "id", "onClick"]),
              _hoisted_2
            ]),
            _createTextVNode(_toDisplayString(JSON.parse(ability?.name)[`${_ctx.systemLocale}`].name) + " ", 1),
            _createVNode("ul", _hoisted_3, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(ability.abilities, (abilityChild, index2) => {
                return (_openBlock(), _createBlock("li", {
                  class: "list-group-item",
                  key: index2
                }, [
                  _createVNode("label", _hoisted_4, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedAbilities = $event)),
                      id: abilityChild.value,
                      onClick: ($event: any) => (_ctx.singleSelectHandler($event, ability.abilities, abilityChild.value, ability.id, index)),
                      value: abilityChild.value
                    }, null, 8, ["id", "onClick", "value"]), [
                      [_vModelCheckbox, _ctx.selectedAbilities]
                    ]),
                    _hoisted_5
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t(`message.${abilityChild?.value.toUpperCase()}`)), 1)
                ]))
              }), 128))
            ])
          ]),
          _: 2
        }, 1032, ["title", "name"]))
      }), 128))
    ]),
    _: 1
  }))
}